import React from "react";
import { Loader } from "../../../Shared";
import {
  JobList,
  JobTitle,
  JobContainer,
  Details,
  DetailItem,
} from "./style.ts";

const DISPLAY_NUMBER = 5;

const getRandom = (array) => {
  if (array === undefined) return [];
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

const SimilarPositions = ({ jobs, address, pending }) => (
  <div className="clearfix">
    <h3>Similar Positions</h3>
    <Loader show={pending} linear />
    <JobList>
      {getRandom(jobs, DISPLAY_NUMBER).map((job) => (
        <JobContainer key={job.id}>
          <JobTitle>
            <a href={`/jobs/${job.slug}`}>{job.title}</a>
          </JobTitle>
          <Details>
            {job.company_name && (
              <DetailItem>
                <i className="fa fa-building" /> {job.company_name}
              </DetailItem>
            )}
            {address(job) && (
              <DetailItem>
                <i className="fa fa-location-arrow" /> {address(job)}
              </DetailItem>
            )}
          </Details>
        </JobContainer>
      ))}
    </JobList>
  </div>
);

export default SimilarPositions;
